// Generated by purs version 0.15.15
import * as Control_Category from "../Control.Category/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Record from "../Data.Record/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
var Delayed = function (x) {
    return x;
};
var unwrapFunctorIdentity = {
    unwrapFunctor: function (v) {
        return v;
    }
};
var unwrapFunctorDelayedDelay = {
    unwrapFunctor: /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn)
};
var newtypeDelayed_ = {
    Coercible0: function () {
        return undefined;
    }
};
var functorDelayed = Specular_FRP_Base.functorDynamic;
var map = /* #__PURE__ */ Data_Functor.map(functorDelayed);
var hasFieldDelayedDelayed = function (dictHasField) {
    var getField = Data_Record.getField(dictHasField);
    return {
        getField: function (label) {
            return map(getField(label));
        }
    };
};
var applyDelayed = Specular_FRP_Base.applyDynamic;
var applicativeDelayed = Specular_FRP_Base.applicativeDynamic;
var unwrapFunctor = function (dict) {
    return dict.unwrapFunctor;
};
var readDelayed = function (dictMonadEffect) {
    var readDynamic = Specular_FRP_Base.readDynamic(dictMonadEffect);
    return function (v) {
        return readDynamic(v);
    };
};
export {
    unwrapFunctor,
    Delayed,
    readDelayed,
    functorDelayed,
    applyDelayed,
    applicativeDelayed,
    newtypeDelayed_,
    hasFieldDelayedDelayed,
    unwrapFunctorDelayedDelay,
    unwrapFunctorIdentity
};
